module.exports = __webpack_public_path__ + "img/counter_u_ledge.735cf72e.png";